
















































































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import IconBase from '@/components/IconBase.vue'
import IconMenu from '@/components/icons/IconMenu.vue'
import VueMaterial from '../../node_modules/vue-material'
import '../../node_modules/vue-material/dist/vue-material.min.css'
import { NavigationItem } from '@/models/navigations'

Vue.use(VueMaterial)
@Component({
  components: {
    IconBase,
    IconMenu
  }
})
export default class Home extends Vue {
  mounted () {
    this.check()
  }

  check () {
    const self = this // Save reference to this
    setTimeout(function () {
      const videoElement: any = self.$refs.videoBg // Target video element
      if (!videoElement.playing) { // Check if video is playing
        videoElement.play() // Force play if not
      }
    }, 200) // Give the player some time to start
  }

  scrollToTarget () {
    const targetElement = document.getElementById('targetSection')
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }

  NAVIGATION = [
    { svg: '', text: 'Podcast', url: '' },
    { svg: '', text: 'Blog', url: 'https://blog.nucleus.medics.academy/' },
    { svg: '', text: 'Sign In', url: 'https://sso.medics.academy/signin' },
    // { svg: '', text: 'Buy Now', url: 'https://sso.medics.academy/signup?checkout=true&product_id=837291&price_id=893107' }
    { svg: '', text: 'Sign Up', url: 'https://www.medics.academy/users/sign_up' }
  ];
}

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function () {
    return (this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2)
  }
})
